// Library Methods
import { useQuery } from "@tanstack/react-query";

// Hooks
import useTokenAccess from "src/hooks/auth/useTokenAccess";

// Types and API
import { DeviceType } from "../types";
import { getClinicDevices } from "../api";

export const useClinicDevices = (
  clinicId: string | undefined,
  enabled = true
) => {
  const { getToken } = useTokenAccess();

  return useQuery<Array<DeviceType>>({
    queryKey: ["clinic-devices", clinicId],
    queryFn: async () => {
      if (!clinicId) throw new Error();

      const token = await getToken();
      const controller = new AbortController();
      return getClinicDevices(token, clinicId, controller.signal);
    },
    enabled,
    refetchOnWindowFocus: false,
    staleTime: 5 * 60 * 1000, // optional: cache for 5 minutes
  });
};
